import React from 'react';
import ClientForm from '../ClientForm/ClientForm';

const EditClient = () => {
  return <ClientForm isEdit={true} />
};

export default EditClient;
